import React, { useEffect } from 'react';
import PageIntro from '../components/PageIntro';
import FeeNotice from '../components/FeeNotice';

const Contact: React.FC = () => {
  useEffect(() => { document.title = 'Get an advocate — Haven Crest Health'; }, []);
  return (
    <main>
      <PageIntro
        eyebrow="Get started"
        title={<>Get an advocate, <em>free.</em></>}
        lede="Email us and we'll pair you with a navigator and set up your own @havencresthealth.com inbox. It's free, it's voluntary, and your first records request is one click away once you're in."
      >
        <div className="hero__ctas">
          <a href="mailto:info@havencresthealth.com?subject=Please%20set%20up%20my%20Haven%20Crest%20inbox" className="btn btn--accent">Email us to get started <span className="arrow">→</span></a>
        </div>
      </PageIntro>

      <section className="section">
        <div className="wrap grid grid--split">
          <div>
            <div className="eyebrow">What happens next</div>
            <div className="steps" style={{ gridTemplateColumns: '1fr 1fr' }}>
              <div className="step"><h3>Send one email</h3><p>Your name and the best way to reach you, to <span className="mono">info@havencresthealth.com</span>.</p></div>
              <div className="step"><h3>Meet your navigator</h3><p>Usually within one business day, with your inbox set up and a short walkthrough.</p></div>
              <div className="step"><h3>Add your doctors</h3><p>The offices, clinics, or hospitals you've seen. A name and a city is enough.</p></div>
              <div className="step"><h3>Click Request</h3><p>We send it on your behalf and follow up. Records land in your inbox.</p></div>
            </div>
          </div>
          <div className="grid" style={{ gap: '1.2rem' }}>
            <div className="card">
              <h3>Contact</h3>
              <p><span className="pill">Sign-ups & questions</span><br /><a href="mailto:info@havencresthealth.com">info@havencresthealth.com</a></p>
              <p style={{ marginBottom: 0 }}><span className="pill">Records team · for providers' offices</span><br /><a href="mailto:records@havencresthealth.com">records@havencresthealth.com</a></p>
            </div>
            <FeeNotice compact />
          </div>
        </div>
      </section>

      <section className="section section--rule">
        <div className="wrap">
          <div className="eyebrow">Before you sign up</div>
          <h2>Questions people ask.</h2>
          <div className="faq" style={{ marginTop: '1.5rem' }}>
            <details open><summary>Is it really free?</summary><p>Yes. The inbox, the records requests, the follow-up, and the navigation help are free. We don't bill you for anything.</p></details>
            <details><summary>Then who pays if a provider charges for records?</summary><p>You do. Some providers are allowed to charge a fee for copies. If you ask us to send a request and the provider decides to bill for it, that fee is your responsibility. We tell you as soon as an office says a fee applies, and you decide whether to proceed.</p></details>
            <details><summary>Is it like Gmail?</summary><p>Close. It's a normal email inbox with a few extra features built for healthcare: the one-click Request button, a tracker for each request, and people you can ask for help.</p></details>
            <details><summary>Do I have to use it?</summary><p>No. It's voluntary. Nothing is sent to any provider unless you click Request, and you can stop using Haven Crest whenever you want.</p></details>
            <details><summary>Do you provide medical care?</summary><p>No. We help you get and understand your records and find doctors. Diagnosis, treatment, and medical advice come from licensed clinicians, not from us.</p></details>
            <details><summary>How long do records take?</summary><p>It depends on the office. Many respond within a couple of weeks; some take longer. We follow up so you don't have to, and the tracker shows where each request stands.</p></details>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
